import { Toaster as Sonner, type ToasterProps } from "sonner";
import { useColorScheme } from "@/providers/theme-provider";

function Toaster(props: ToasterProps) {
  const { resolved } = useColorScheme();
  return (
    <Sonner
      theme={resolved}
      position="top-right"
      offset={16}
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group !rounded-xl !border !border-border !bg-popover !text-popover-foreground !shadow-2xl",
          description: "!text-muted-foreground",
          actionButton: "!bg-primary !text-primary-foreground !rounded-md",
          cancelButton: "!bg-secondary !text-secondary-foreground !rounded-md",
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
